import {Scalars} from '../graphql/scalars';
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

/**
 * An enumeration.
 */
export enum ActionEnum {
  RESEND_ATR_REQUEST = 'RESEND_ATR_REQUEST',
  RESEND_FACT_FIND_REQUEST = 'RESEND_FACT_FIND_REQUEST',
  RESEND_FPA_SIGNATURE_REQUEST = 'RESEND_FPA_SIGNATURE_REQUEST',
}

/**
 * An enumeration.
 */
export enum AdhocFeeTypeEnum {
  GBP = 'GBP',
  PERCENT = 'PERCENT',
}

/**
 * An enumeration.
 */
export enum AnnuityIncomeFrequencyEnum {
  ANNUALLY = 'ANNUALLY',
  BI_ANNUALLY = 'BI_ANNUALLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  WEEKLY = 'WEEKLY',
}

/**
 * An enumeration.
 */
export enum AnnuityPaymentTypeEnum {
  IN_ADVANCE = 'IN_ADVANCE',
  IN_ARREARS = 'IN_ARREARS',
}

/**
 * An enumeration.
 */
export enum AnnuityRateTypeEnum {
  IMPAIRED_LIFE = 'IMPAIRED_LIFE',
  ORDINARY_RATES = 'ORDINARY_RATES',
}

/**
 * An enumeration.
 */
export enum AnnuityTypeEnum {
  FIXED_TERM_ANNUITY = 'FIXED_TERM_ANNUITY',
  LONG_TERM_CARE_PREFUNDED = 'LONG_TERM_CARE_PREFUNDED',
  PERSONAL_PENSION_ANNUITY = 'PERSONAL_PENSION_ANNUITY',
}

export enum AtrStatusCategory {
  amended_pending = 'amended_pending',
  closed = 'closed',
  completed = 'completed',
  manual = 'manual',
  not_started = 'not_started',
  pending = 'pending',
}

/**
 * An enumeration.
 */
export enum BankDetailsEnum {
  NEED_VALIDATING = 'NEED_VALIDATING',
  NOT_KNOWN = 'NOT_KNOWN',
}

export enum BulkAdminSortableFieldsEnum {
  ACCOUNT_NAME = 'ACCOUNT_NAME',
  ATR_DATE = 'ATR_DATE',
  CLIENT_NAME = 'CLIENT_NAME',
  CQ_UPDATED = 'CQ_UPDATED',
  NEXT_REVIEW_DATE = 'NEXT_REVIEW_DATE',
  PROPOSITION_TYPE = 'PROPOSITION_TYPE',
}

/**
 * An enumeration.
 */
export enum BusinessUnitEnum {
  AR = 'AR',
  DA = 'DA',
  SFP = 'SFP',
}

export enum ClientPortalStatusCategory {
  archived = 'archived',
  compromised = 'compromised',
  confirmed = 'confirmed',
  does_not_exist = 'does_not_exist',
  force_change_password = 'force_change_password',
  not_started = 'not_started',
  reset_required = 'reset_required',
  unconfirmed = 'unconfirmed',
  unknown = 'unknown',
}

/**
 *
 * This enum is used in contribution, more specify used in mutation
 * `UpsertContribute`.
 *
 * These options match exactly what contribute UI allows user to select.
 *
 */
export enum ComboFrequencyEnum {
  ANNUAL = 'ANNUAL',
  ANNUAL_AND_SINGLE = 'ANNUAL_AND_SINGLE',
  MONTHLY = 'MONTHLY',
  MONTHLY_AND_SINGLE = 'MONTHLY_AND_SINGLE',
  QUARTERLY = 'QUARTERLY',
  QUARTERLY_AND_SINGLE = 'QUARTERLY_AND_SINGLE',
  SINGLE = 'SINGLE',
}

/**
 * An enumeration.
 */
export enum CommunicationMethod {
  EMAIL = 'EMAIL',
  FACE_TO_FACE = 'FACE_TO_FACE',
  POST = 'POST',
  TELEPHONE = 'TELEPHONE',
}

/**
 * An enumeration.
 */
export enum ContactATRECQStatusEnum {
  IN_DATE = 'IN_DATE',
  MISSING = 'MISSING',
  OUTDATED = 'OUTDATED',
  SENT = 'SENT',
  UP_TO_DATE = 'UP_TO_DATE',
}

/**
 * An enumeration.
 */
export enum ContributionFrequencyTypes {
  ANNUALLY = 'ANNUALLY',
  HALF_YEARLY = 'HALF_YEARLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

/**
 * An enumeration.
 */
export enum ContributionPaymentDateTypes {
  FIFTEENTH = 'FIFTEENTH',
  FIRST = 'FIRST',
}

/**
 * An enumeration.
 */
export enum ContributionSourceTypes {
  EMPLOYER = 'EMPLOYER',
  PERSONAL = 'PERSONAL',
}

/**
 * An enumeration.
 */
export enum ContributionTypes {
  REGULAR = 'REGULAR',
  SINGLE = 'SINGLE',
}

/**
 * An enumeration.
 */
export enum DocumentGroup {
  COMPLETED_FORMS_AUTHORITY_TO_PROCEED = 'COMPLETED_FORMS_AUTHORITY_TO_PROCEED',
  COMPLETED_FORMS_CONTRIBUTION_FORM = 'COMPLETED_FORMS_CONTRIBUTION_FORM',
  COMPLETED_FORMS_DECLARATION_FORM = 'COMPLETED_FORMS_DECLARATION_FORM',
  COMPLETED_FORMS_DIRECT_DEBIT_MANDATE = 'COMPLETED_FORMS_DIRECT_DEBIT_MANDATE',
  COMPLETED_FORMS_DRAWDOWN_FORM = 'COMPLETED_FORMS_DRAWDOWN_FORM',
  COMPLETED_FORMS_EXPRESSION_OF_WISH = 'COMPLETED_FORMS_EXPRESSION_OF_WISH',
  COMPLETED_FORMS_ILLUSTRATION_REQUEST = 'COMPLETED_FORMS_ILLUSTRATION_REQUEST',
  COMPLETED_FORMS_ISA_APPLICATION = 'COMPLETED_FORMS_ISA_APPLICATION',
  COMPLETED_FORMS_JISA_APPLICATION = 'COMPLETED_FORMS_JISA_APPLICATION',
  COMPLETED_FORMS_LETTER_OF_AUTHORITY = 'COMPLETED_FORMS_LETTER_OF_AUTHORITY',
  COMPLETED_FORMS_LUMP_SUM_ALLOWANCE_DECLARATION = 'COMPLETED_FORMS_LUMP_SUM_ALLOWANCE_DECLARATION',
  COMPLETED_FORMS_NOMINEE_TRANSFER_FORM = 'COMPLETED_FORMS_NOMINEE_TRANSFER_FORM',
  COMPLETED_FORMS_TRANSFER_IN_FORM = 'COMPLETED_FORMS_TRANSFER_IN_FORM',
  COMPLETED_FORMS_TRANSFER_OUT_FORM = 'COMPLETED_FORMS_TRANSFER_OUT_FORM',
  COMPLETED_FORMS_TRUST_DECLARATION = 'COMPLETED_FORMS_TRUST_DECLARATION',
}

export enum DocumentUploadPlanNumberStatus {
  PLAN_NUMBER_NEEDED_KNOWN = 'PLAN_NUMBER_NEEDED_KNOWN',
  PLAN_NUMBER_NEEDED_NOT_KNOWN = 'PLAN_NUMBER_NEEDED_NOT_KNOWN',
  PLAN_NUMBER_NOT_NEEDED = 'PLAN_NUMBER_NOT_NEEDED',
}

export enum DummyEnum {
  FALSE = 'FALSE',
  TRUE = 'TRUE',
}

/**
 * An enumeration.
 */
export enum EmailAuditStatusEnum {
  bounced = 'bounced',
  click = 'click',
  complaint = 'complaint',
  delay = 'delay',
  open = 'open',
  received = 'received',
  transit = 'transit',
}

/**
 * An enumeration.
 */
export enum FPACancellationReasonEnum {
  CLIENT_REFUSED = 'CLIENT_REFUSED',
  OTHER_MEDIA = 'OTHER_MEDIA',
}

/**
 * An enumeration.
 */
export enum FinCalcSessionTypeEnum {
  ADVISER = 'ADVISER',
  CLIENT = 'CLIENT',
  PREFILL = 'PREFILL',
}

/**
 * An enumeration.
 */
export enum FormTransferTypes {
  CASH = 'CASH',
  HOLDINGS = 'HOLDINGS',
  STOCKS = 'STOCKS',
}

/**
 * An enumeration.
 */
export enum FormTypes {
  BANK_DETAIL_COLLECTION = 'BANK_DETAIL_COLLECTION',
  EXPRESSION_OF_WISHES = 'EXPRESSION_OF_WISHES',
  FURTHER_ACTION = 'FURTHER_ACTION',
  ISA_APPLICATION = 'ISA_APPLICATION',
  ISA_TRANSFER = 'ISA_TRANSFER',
  JISA_APPLICATION = 'JISA_APPLICATION',
  JISA_TRANSFER = 'JISA_TRANSFER',
  MULTREES_DDM = 'MULTREES_DDM',
  NOMINEE_TRANSFER = 'NOMINEE_TRANSFER',
  SIPP_CONTRIBUTION = 'SIPP_CONTRIBUTION',
  SIPP_DDM = 'SIPP_DDM',
  SIPP_TRANSFER = 'SIPP_TRANSFER',
}

/**
 *
 * contains all group permissions
 *
 */
export enum GlobalPermissionEnum {
  can_access_admin_features = 'can_access_admin_features',
  can_access_alphabetical_accounts_dashboard_FE = 'can_access_alphabetical_accounts_dashboard_FE',
  can_access_annual_reviews = 'can_access_annual_reviews',
  can_access_annual_reviews_temp = 'can_access_annual_reviews_temp',
  can_access_api_features = 'can_access_api_features',
  can_access_atrs = 'can_access_atrs',
  can_access_basic_features = 'can_access_basic_features',
  can_access_bulk_accounts = 'can_access_bulk_accounts',
  can_access_calendly_FE = 'can_access_calendly_FE',
  can_access_charges = 'can_access_charges',
  can_access_client_creator = 'can_access_client_creator',
  can_access_client_portal_FE = 'can_access_client_portal_FE',
  can_access_cqs = 'can_access_cqs',
  can_access_curo_FE = 'can_access_curo_FE',
  can_access_dentist_recommendation_builder = 'can_access_dentist_recommendation_builder',
  can_access_document_upload = 'can_access_document_upload',
  can_access_document_upload_v2 = 'can_access_document_upload_v2',
  can_access_documents = 'can_access_documents',
  can_access_ehons_notes_goals = 'can_access_ehons_notes_goals',
  can_access_ehons_reqs = 'can_access_ehons_reqs',
  can_access_fincalc = 'can_access_fincalc',
  can_access_fpa = 'can_access_fpa',
  can_access_imago = 'can_access_imago',
  can_access_instructions_FE = 'can_access_instructions_FE',
  can_access_lead_creator = 'can_access_lead_creator',
  can_access_limited_features = 'can_access_limited_features',
  can_access_notes = 'can_access_notes',
  can_access_notes_v2 = 'can_access_notes_v2',
  can_access_oneview = 'can_access_oneview',
  can_access_pad_junior_handover_modal_FE = 'can_access_pad_junior_handover_modal_FE',
  can_access_pad_no_requirements_FE = 'can_access_pad_no_requirements_FE',
  can_access_pad_only_features_FE = 'can_access_pad_only_features_FE',
  can_access_pad_relationship_manager_handover_modal_FE = 'can_access_pad_relationship_manager_handover_modal_FE',
  can_access_pad_senior_handover_modal_FE = 'can_access_pad_senior_handover_modal_FE',
  can_access_paginated_accounts_dashboard_FE = 'can_access_paginated_accounts_dashboard_FE',
  can_access_report_pack = 'can_access_report_pack',
  can_access_report_pack_declined_uncontactable_letter_FE = 'can_access_report_pack_declined_uncontactable_letter_FE',
  can_access_report_pack_no_action_letter_FE = 'can_access_report_pack_no_action_letter_FE',
  can_access_risk_notes = 'can_access_risk_notes',
  can_access_risk_profile = 'can_access_risk_profile',
  can_access_saltus_only_features_FE = 'can_access_saltus_only_features_FE',
  can_access_sfp_support_FE = 'can_access_sfp_support_FE',
  can_access_spp_support_FE = 'can_access_spp_support_FE',
  can_access_xperidoc = 'can_access_xperidoc',
  can_change_business_unit = 'can_change_business_unit',
  can_restore_admin_permission = 'can_restore_admin_permission',
  can_use_adhoc_fees = 'can_use_adhoc_fees',
}

/**
 * An enumeration.
 */
export enum ISAFormSubscriptionTypes {
  BANK_TRANSFER = 'BANK_TRANSFER',
  CHEQUE = 'CHEQUE',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  EXISTING_ACCOUNT = 'EXISTING_ACCOUNT',
}

/**
 * An enumeration.
 */
export enum IdentityGroupActionEnum {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

/**
 * An enumeration.
 */
export enum IdentityGroupEnum {
  ADMIN = 'ADMIN',
  ADVISER = 'ADVISER',
  CLIENT = 'CLIENT',
  ONEVIEW = 'ONEVIEW',
}

export enum InvitationReviewsInput {
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  INVITED = 'INVITED',
  SCHEDULED = 'SCHEDULED',
  TODAYS_MEETINGS = 'TODAYS_MEETINGS',
  TO_INVITE = 'TO_INVITE',
  UNCONTACTABLE = 'UNCONTACTABLE',
}

/**
 * An enumeration.
 */
export enum InvitationStatus {
  COMPLETED = 'COMPLETED',
  DECLINED = 'DECLINED',
  INVITED = 'INVITED',
  SCHEDULED = 'SCHEDULED',
  UNCONTACTABLE = 'UNCONTACTABLE',
}

/**
 * An enumeration.
 */
export enum IsaTransferTypes {
  FULL = 'FULL',
  PARTIAL = 'PARTIAL',
}

/**
 * An enumeration.
 */
export enum JISAFormSubscriptionTypes {
  BACS = 'BACS',
  CHEQUE = 'CHEQUE',
  DIRECT_DEBIT = 'DIRECT_DEBIT',
}

/**
 * An enumeration.
 */
export enum MeetingType {
  PHONE = 'PHONE',
  REMOTE = 'REMOTE',
}

/**
 * An enumeration.
 */
export enum NomineeTransferFormTypes {
  HOLDINGS = 'HOLDINGS',
  STOCKS = 'STOCKS',
}

/**
 * An enumeration.
 */
export enum OVModelsEnum {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  GOAL = 'GOAL',
  INVITATION = 'INVITATION',
  LEAD = 'LEAD',
  MODEL_PORTFOLIO = 'MODEL_PORTFOLIO',
  NOTE = 'NOTE',
  OVRECOMMEND = 'OVRECOMMEND',
  OVRECOMMENDPOT = 'OVRECOMMENDPOT',
  POT = 'POT',
  RECOMMENDATION = 'RECOMMENDATION',
  REVIEW = 'REVIEW',
  STAFF = 'STAFF',
  TASK = 'TASK',
}

/**
 * An enumeration.
 */
export enum OVRecommendActionEnum {
  ACTION = 'ACTION',
  AD_HOC_FEE = 'AD_HOC_FEE',
  CONTRIBUTE = 'CONTRIBUTE',
  MODIFY = 'MODIFY',
  SET_UP_NEW = 'SET_UP_NEW',
  TRANSFER = 'TRANSFER',
  WITHDRAW = 'WITHDRAW',
}

/**
 * An enumeration.
 */
export enum OneViewModelTypesEnum {
  ACCOUNT = 'ACCOUNT',
  ACTIVITYGROUP = 'ACTIVITYGROUP',
  ACTIVITYSUBGROUP = 'ACTIVITYSUBGROUP',
  ANNOTATION = 'ANNOTATION',
  ASSET = 'ASSET',
  ATR = 'ATR',
  BUSINESSUNIT = 'BUSINESSUNIT',
  CLIENTEXPENDITURE = 'CLIENTEXPENDITURE',
  CLIENTINCOME = 'CLIENTINCOME',
  CONTACT = 'CONTACT',
  CURRENCY = 'CURRENCY',
  FEECOMPONENT = 'FEECOMPONENT',
  FEEPROFILE = 'FEEPROFILE',
  GIFT = 'GIFT',
  GOAL = 'GOAL',
  INCOMEPROFILE = 'INCOMEPROFILE',
  INTERESTEDPARTY = 'INTERESTEDPARTY',
  LEAD = 'LEAD',
  LIABILITY = 'LIABILITY',
  MODELPORTFOLIO = 'MODELPORTFOLIO',
  POT = 'POT',
  PRODUCT = 'PRODUCT',
  PRODUCTPROVIDED = 'PRODUCTPROVIDED',
  PROJECT = 'PROJECT',
  PROJECTCATEGORY = 'PROJECTCATEGORY',
  PROJECTSTAGE = 'PROJECTSTAGE',
  PROVIDER = 'PROVIDER',
  PROVIDERCONTACT = 'PROVIDERCONTACT',
  RECOMMENDATION = 'RECOMMENDATION',
  REVIEW = 'REVIEW',
  SITE = 'SITE',
  STAFF = 'STAFF',
  TASK = 'TASK',
}

/**
 * An enumeration.
 */
export enum OneviewContactAtrStatusChoices {
  IN_DATE = 'IN_DATE',
  MISSING = 'MISSING',
  OUTDATED = 'OUTDATED',
  SENT = 'SENT',
  UP_TO_DATE = 'UP_TO_DATE',
}

/**
 * An enumeration.
 */
export enum OneviewContactEcqStatusChoices {
  IN_DATE = 'IN_DATE',
  MISSING = 'MISSING',
  OUTDATED = 'OUTDATED',
  SENT = 'SENT',
  UP_TO_DATE = 'UP_TO_DATE',
}

/**
 * An enumeration.
 */
export enum OneviewDocumentSignatureRequestStatusChoices {
  CANCELLED = 'CANCELLED',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  SENT = 'SENT',
  SIGNED = 'SIGNED',
}

/**
 * An enumeration.
 */
export enum OneviewInvitationCreatedBySystemChoices {
  CURO = 'CURO',
  ONEVIEW = 'ONEVIEW',
}

/**
 * An enumeration.
 */
export enum OneviewReportPackFormCreatedBySystemChoices {
  CURO = 'CURO',
  ONEVIEW = 'ONEVIEW',
}

/**
 * An enumeration.
 */
export enum OneviewReviewReviewActionChoices {
  DECLINED_BY_CLIENT = 'DECLINED_BY_CLIENT',
  NO_RESPONSE_FROM_CLIENT = 'NO_RESPONSE_FROM_CLIENT',
  REVIEW_MEETING = 'REVIEW_MEETING',
}

/**
 * An enumeration.
 */
export enum OneviewTaskSelectedEntityTypeChoices {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  CUROGENERICMODEL = 'CUROGENERICMODEL',
  GOAL = 'GOAL',
  LEAD = 'LEAD',
  POT = 'POT',
  RECOMMENDATION = 'RECOMMENDATION',
  REQUIREMENT = 'REQUIREMENT',
  REVIEW = 'REVIEW',
}

/**
 * An enumeration.
 */
export enum PermGroupsEnum {
  god = 'god',
  pad_junior = 'pad_junior',
  pad_relationship_manager = 'pad_relationship_manager',
  pad_senior = 'pad_senior',
  saltus_na = 'saltus_na',
  sam = 'sam',
  sfp = 'sfp',
  spp_ar = 'spp_ar',
  spp_da = 'spp_da',
  visitor = 'visitor',
}

/**
 * An enumeration.
 */
export enum ProtectionTypeEnum {
  critical_illness = 'critical_illness',
  decreasing_term = 'decreasing_term',
  family_income = 'family_income',
  income_protection = 'income_protection',
  level_term = 'level_term',
  other = 'other',
}

/**
 * An enumeration.
 */
export enum PullEntityType {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  LEAD = 'LEAD',
  REVIEW = 'REVIEW',
  SYSTEM_USER = 'SYSTEM_USER',
}

/**
 * An enumeration.
 */
export enum RecurringFrequencyEnum {
  ANNUAL = 'ANNUAL',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SINGLE = 'SINGLE',
}

/**
 * An enumeration.
 */
export enum ReportPackFormStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
}

/**
 * An enumeration.
 */
export enum ReportPackStatus {
  CANCELLED = 'CANCELLED',
  EXPIRED = 'EXPIRED',
  IN_PROGRESS = 'IN_PROGRESS',
  NO_LONGER_NEEDED = 'NO_LONGER_NEEDED',
  PARTLY_READ = 'PARTLY_READ',
  PARTLY_SIGNED = 'PARTLY_SIGNED',
  READ = 'READ',
  READY_TO_SUBMIT = 'READY_TO_SUBMIT',
  SIGNED = 'SIGNED',
  SUBMITTED = 'SUBMITTED',
}

/**
 * An enumeration.
 */
export enum ReportPackTemplateATRTypeEnum {
  ALIGNED_ATR = 'ALIGNED_ATR',
  MISALIGNED_ATR = 'MISALIGNED_ATR',
  NO_ATR = 'NO_ATR',
}

/**
 * An enumeration.
 */
export enum ReportPackTemplateDocumentTypeEnum {
  EOW = 'EOW',
  POA = 'POA',
  TASKS = 'TASKS',
  WILL = 'WILL',
}

/**
 * An enumeration.
 */
export enum ReportPackTemplateMonthsEnum {
  TWELVE = 'TWELVE',
  TWENTYFOUR = 'TWENTYFOUR',
}

/**
 * An enumeration.
 */
export enum ReportPackTemplateNewOrExistingClientEnum {
  EXISTING = 'EXISTING',
  NEW = 'NEW',
}

/**
 * An enumeration.
 */
export enum ReportPackTemplateTypes {
  ATTACHMENT_LETTER = 'ATTACHMENT_LETTER',
  DECLINED_LETTER = 'DECLINED_LETTER',
  NO_ACTION_LETTER = 'NO_ACTION_LETTER',
  UNCONTACTABLE_LETTER = 'UNCONTACTABLE_LETTER',
}

/**
 * An enumeration.
 */
export enum ReviewAction {
  CLIENT_DECLINED = 'CLIENT_DECLINED',
  NO_RESPONSE = 'NO_RESPONSE',
  REVIEW_MEETING = 'REVIEW_MEETING',
}

/**
 * An enumeration.
 */
export enum ReviewAdviceActionEnum {
  ADVICE_NEEDED = 'ADVICE_NEEDED',
  NO_ADVICE = 'NO_ADVICE',
}

export enum ReviewAllowedActionsType {
  BOOK_FOR_CLIENT = 'BOOK_FOR_CLIENT',
  CANCEL_FOR_CLIENT = 'CANCEL_FOR_CLIENT',
  JOIN_MEETING = 'JOIN_MEETING',
  RESCHEDULE_FOR_CLIENT = 'RESCHEDULE_FOR_CLIENT',
  SEND_ECQ = 'SEND_ECQ',
  SEND_INVITATION = 'SEND_INVITATION',
  SEND_RTQ = 'SEND_RTQ',
}

/**
 * An enumeration.
 */
export enum ReviewForEnum {
  ACCOUNT = 'ACCOUNT',
  JOINT = 'JOINT',
  SINGLE = 'SINGLE',
}

/**
 * An enumeration.
 */
export enum ReviewStage {
  AWAITING_CLIENT = 'AWAITING_CLIENT',
  AWAITING_HANDOVER = 'AWAITING_HANDOVER',
  BEING_IMPLEMENTED = 'BEING_IMPLEMENTED',
  BOOKED = 'BOOKED',
  LIVE_CASES = 'LIVE_CASES',
  NEED_BOOKING = 'NEED_BOOKING',
}

/**
 *
 * this enum contains values for the "status_oneview" field of Review Model,
 * note that this "status_oneview" does NOT come from Curo and only exists in Oneview.
 *
 */
export enum ReviewStatusOneviewEnum {
  AWAITING_EHONS = 'AWAITING_EHONS',
  CLOSED = 'CLOSED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
  MEETING_BOOKED = 'MEETING_BOOKED',
  OPEN = 'OPEN',
  PLANNED = 'PLANNED',
  SOFT_SUBMITTED = 'SOFT_SUBMITTED',
}

/**
 * An enumeration.
 */
export enum RiskType {
  BEHAVIOURAL_CAPACITY = 'BEHAVIOURAL_CAPACITY',
  CAPACITY_FOR_LOSS = 'CAPACITY_FOR_LOSS',
  FINANCIAL_CAPACITY = 'FINANCIAL_CAPACITY',
  KNOWLEDGE_AND_BEHAVIOUR = 'KNOWLEDGE_AND_BEHAVIOUR',
  KNOWLEDGE_AND_EXPERIENCE = 'KNOWLEDGE_AND_EXPERIENCE',
  RISK_CAPACITY = 'RISK_CAPACITY',
  RISK_TOLERANCE = 'RISK_TOLERANCE',
  TIMEFRAMES = 'TIMEFRAMES',
  VALUES = 'VALUES',
  VALUES_AND_SERVICE = 'VALUES_AND_SERVICE',
}

export enum SelectPropositionTypeEnum {
  SELECT_CONVERSIONS = 'SELECT_CONVERSIONS',
  SELECT_SAM_ONLY = 'SELECT_SAM_ONLY',
  SELECT_TRANSIT = 'SELECT_TRANSIT',
  SELECT_WITH_FP = 'SELECT_WITH_FP',
}

export enum SortingDirectionEnum {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

/**
 * An enumeration.
 */
export enum StatusAtReviewEnum {
  AHEAD_OF_TARGET = 'AHEAD_OF_TARGET',
  BEHIND_TARGET = 'BEHIND_TARGET',
  NO_LONGER_REQUIRED = 'NO_LONGER_REQUIRED',
  ON_TARGET = 'ON_TARGET',
  SATISFIED = 'SATISFIED',
  UNDEFINED = 'UNDEFINED',
}

/**
 * An enumeration.
 */
export enum TaskActivityStatusEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  OPEN = 'OPEN',
}

/**
 * An enumeration.
 */
export enum TaskPriorityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
}

/**
 * An enumeration.
 */
export enum TaskRegardingEntityEnum {
  ACCOUNT = 'ACCOUNT',
  CONTACT = 'CONTACT',
  LEAD = 'LEAD',
  PLAN = 'PLAN',
  PLANNING_OBJECTIVE = 'PLANNING_OBJECTIVE',
  RECOMMENDATION = 'RECOMMENDATION',
  REQUIREMENT = 'REQUIREMENT',
  REVIEW = 'REVIEW',
  THIRD_PARTY = 'THIRD_PARTY',
}

/**
 * An enumeration.
 */
export enum TaskStatusReasonEnum {
  CANCELLED = 'CANCELLED',
  COMPLETED = 'COMPLETED',
  DEFERRED = 'DEFERRED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  WAITING_ON_SOMEONE_ELSE = 'WAITING_ON_SOMEONE_ELSE',
}

/**
 * An enumeration.
 */
export enum TaskUrgencyEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  NORMAL = 'NORMAL',
  TAX_YEAR_SENSITIVE = 'TAX_YEAR_SENSITIVE',
  TYE = 'TYE',
  URGENT = 'URGENT',
}

/**
 * An enumeration.
 */
export enum TransferDrawdownTypes {
  ENTIRELY = 'ENTIRELY',
  NONE = 'NONE',
  PARTIALLY = 'PARTIALLY',
}

/**
 * An enumeration.
 */
export enum TransferSchemeTypes {
  DEFINED_BENEFIT = 'DEFINED_BENEFIT',
  MONEY_PURCHASE = 'MONEY_PURCHASE',
  PERSONAL_PENSION = 'PERSONAL_PENSION',
  RECOGNISED_OVERSEAS = 'RECOGNISED_OVERSEAS',
  RETIREMENT_ANNUITY = 'RETIREMENT_ANNUITY',
  SIPP = 'SIPP',
  SSAS = 'SSAS',
}

/**
 *
 * contains all user permissions
 *
 */
export enum UserPermissionEnum {
  can_access_admin_features = 'can_access_admin_features',
  can_access_annual_reviews_temp = 'can_access_annual_reviews_temp',
  can_access_api_features = 'can_access_api_features',
  can_access_oneview = 'can_access_oneview',
  can_change_business_unit = 'can_change_business_unit',
  can_restore_admin_permission = 'can_restore_admin_permission',
}

/**
 * An enumeration.
 */
export enum UserStatusEnum {
  ARCHIVED = 'ARCHIVED',
  COMPROMISED = 'COMPROMISED',
  CONFIRMED = 'CONFIRMED',
  EXTERNAL_PROVIDER = 'EXTERNAL_PROVIDER',
  FORCE_CHANGE_PASSWORD = 'FORCE_CHANGE_PASSWORD',
  RESET_REQUIRED = 'RESET_REQUIRED',
  UNCONFIRMED = 'UNCONFIRMED',
  UNKNOWN = 'UNKNOWN',
}

export interface AdditionalData {
  templateId?: string | null;
  scope?: string | null;
}

export interface ClientCommunicationAttemptInputType {
  contactDate?: Scalars['Date']['output'] | null;
  contactMethod?: CommunicationMethod | null;
  declineReason?: string | null;
}

export interface DateRangeInput {
  dateFrom?: any | null;
  dateTo?: any | null;
}

export interface ExistingTransferSourceInputType {
  sourcePotId: any;
  isFull: boolean;
  isInSpecie: boolean;
  singleClientAmount: Scalars['Decimal']['output'];
  initialFeeId?: any | null;
  sppInitialFee?: string | null;
}

export interface GenerateOVRPotBatchArguments {
  full?: boolean | null;
  mandate?: string | null;
  modelPortfolioId?: any | null;
  planType: string;
  recurringClientFrequency?: string | null;
  recurringEmployerFrequency?: string | null;
  singleClientAmount?: any | null;
  singleEmployerAmount?: Scalars['Decimal']['output'] | null;
  recurringClientAmount?: Scalars['Decimal']['output'] | null;
  recurringEmployerAmount?: Scalars['Decimal']['output'] | null;
  fees?: any[] | null;
  hasFeeDeviation?: boolean | null;
  initialFee?: Scalars['Decimal']['output'] | null;
  initialEmployerFee?: any | null;
  adhocFeeType?: AdhocFeeTypeEnum | null;
  adhocFeeAmount?: Scalars['Decimal']['output'] | null;
  adhocFeeDate?: Scalars['DateTime']['output'] | null;
  adhocFeeReason?: string | null;
  legacyInitialFee?: string | null;
  legacyInitialEmployerFee?: string | null;
  annuityType?: AnnuityTypeEnum | null;
  incomeFrequency?: AnnuityIncomeFrequencyEnum | null;
  guaranteedPeriod?: Scalars['Decimal']['output'] | null;
  spouseAnnuityPercent?: Scalars['Decimal']['output'] | null;
  rateType?: AnnuityRateTypeEnum | null;
  indexLinked?: boolean | null;
  ltcCapitalProtected?: boolean | null;
  protectedPercentage?: Scalars['Decimal']['output'] | null;
  paymentType?: AnnuityPaymentTypeEnum | null;
  potId?: Scalars['UUID']['output'] | null;
  accountId?: Scalars['UUID']['output'] | null;
  contactId?: Scalars['UUID']['output'] | null;
  productNameId?: any | null;
  productProviderId?: any | null;
  nominatedAccountId?: any | null;
  originalOvrId?: Scalars['UUID']['output'] | null;
  parentId?: any | null;
  reviewId?: Scalars['UUID']['output'] | null;
  bankDetails?: BankDetailsEnum | null;
  name?: string | null;
  ownership?: string | null;
  planNumber?: string | null;
  planStatus?: string | null;
  policyHolder?: string | null;
  proposalReference?: string | null;
  servicingRights?: string | null;
  sortCode?: string | null;
  withdrawalReason?: string | null;
  isDeleted?: boolean | null;
  isDummy?: boolean | null;
  inSpecie?: boolean | null;
  isSubplan?: boolean | null;
  isValidated?: boolean | null;
  resetServicingRights?: boolean | null;
  withdrawalsAllowed?: boolean | null;
  currentDirectValue?: Scalars['Decimal']['output'] | null;
  projectedValue?: Scalars['Decimal']['output'] | null;
  totalIncome?: Scalars['Decimal']['output'] | null;
  totalValue?: Scalars['Decimal']['output'] | null;
  usedValue?: Scalars['Decimal']['output'] | null;
  benefitBasis?: string | null;
  benefitBasisMonthlyText?: string | null;
  deferredPeriod?: string | null;
  indexation?: string | null;
  lifeCover?: Scalars['Decimal']['output'] | null;
  livesAssured?: string | null;
  notes?: string | null;
  protectionType?: ProtectionTypeEnum | null;
  premiumType?: string | null;
  term?: number | null;
  termType?: string | null;
  inTrust?: boolean | null;
  monthlyIncome?: Scalars['Decimal']['output'] | null;
  investmentLinked?: boolean | null;
  waiverOfPremium?: boolean | null;
  terminatingAge?: number | null;
  criticalIllnessCover?: Scalars['Decimal']['output'] | null;
  lifeOrCriticalIllnessCover?: Scalars['Decimal']['output'] | null;
  isCash?: boolean | null;
  isBank?: boolean | null;
  valuationMethod?: boolean | null;
  isAuthorityHeld?: boolean | null;
  isDataGather?: boolean | null;
}

export interface NewTransferSourceInputType {
  contactId?: any | null;
  isFull: boolean;
  isInSpecie: boolean;
  singleClientAmount: any;
  initialFeeId?: any | null;
  sppInitialFee?: string | null;
  productProviderId: any;
  productNameId: any;
  planNumber: string;
  isDataGather: boolean;
  isAuthorityHeld: boolean;
  currentPlanValue: Scalars['Decimal']['output'];
}

export interface ReportPackContactInput {
  contactCuroId?: string | null;
  contactStatus?: string | null;
}

export interface RiskProfileInput {
  reviewId: any;
  contactId: any;
  centralPropositionAgreed?: boolean | null;
  dfmAgreed?: boolean | null;
  hasNoRiskDicussion?: boolean | null;
  isRiskToleranceQuestionnaireDeclined?: boolean | null;
  riskToleranceQuestionnaireDeclineReason?: string | null;
  noChangeReasonNotes?: string | null;
  outcomeRiskScore?: number | null;
  outcomeRiskNotes?: string | null;
}

export interface RiskProfileSectionInput {
  reviewId: any;
  contactId: any;
  riskType: RiskType;
  score?: number | null;
  notes?: string | null;
  noChange?: boolean | null;
}

export interface SubplansInputType {
  modelPortfolioId?: any | null;
  mandate?: string | null;
}

export interface TaxYearInput {
  startYear?: number | null;
  endYear?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
